import {ActivatedRoute} from '@angular/router';
import {Loan} from '../model/loan.model';
import {Component, OnInit} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {Keys, StorageService} from '../service/storage.service';
import {LoanDetailsService} from '../service/loan-details.service';
import {InvestmentMetrics, LenderDetailsService} from '../service/lender-details.service';
import {NpaLoansFilter} from './filters/npa-loans.filter';
import {remove, uniq} from 'lodash';
import {PortfolioService} from '../service/portfolio.service';
import {Portfolio} from '../model/portfolio.model';

export interface LenderDelayedLoan {
    loanId: string;
    rating: string;
    createdAt: Date;
    loan_tenure: number;
    portfolioName: string;
    investmentInLoan: number;
    totalNetAmountOverdue: number;
    numberOfDaysDelayed: number;
    numberOfEmisOverdue: number;
    numberOfEmiReceived: number;
    netInterestEarned: number;
    grossCashFlowReceived: number;
    outstandingPrincipal: number;
    lastPaymentDate: Date;
}

@Component({
    selector: 'app-lender-delayed-loans',
    templateUrl: './lender-delayed-loans.component.html',
    styleUrls: ['./lender-delayed-loans.component.css'],
})
export class LenderDelayedLoansComponent implements OnInit {

    dataSource = new MatTableDataSource<LenderDelayedLoan>();
    name: string;
    metrics: InvestmentMetrics;
    networkCallInProgress: boolean;
    selectedTabIndex: number;
    npaLoans: Loan[];
    nonNpaDelayedLoans: Loan[];
    lenderId: string;
    portfolios: Map<string, Portfolio>;

    private activatedRoute: ActivatedRoute;
    private loanDetailsService: LoanDetailsService;
    private lenderDetailsService: LenderDetailsService;
    private storageService: StorageService;
    private readonly npaLoansFilter: NpaLoansFilter;
    private readonly portfolioService: PortfolioService;

    constructor(lenderDetailsService: LenderDetailsService, loanDetailsService: LoanDetailsService,
                activatedRoute: ActivatedRoute, storageService: StorageService, npaLoansFilter: NpaLoansFilter, portfolioService: PortfolioService) {
        this.storageService = storageService;
        this.activatedRoute = activatedRoute;
        this.loanDetailsService = loanDetailsService;
        this.lenderDetailsService = lenderDetailsService;
        this.npaLoansFilter = npaLoansFilter;
        this.portfolioService = portfolioService;
    }

    async ngOnInit() {
        const userPreferredTab = this.activatedRoute.snapshot.queryParams['selectedIndex'];
        this.selectedTabIndex = userPreferredTab ? userPreferredTab : 0;
        this.networkCallInProgress = true;
        this.lenderId = this.activatedRoute.snapshot.params['lenderId'];
        this.name = this.storageService.getItem(Keys.NAME);
        this.metrics = await this.lenderDetailsService.getMetrics(this.lenderId);
        const delayedLoans = await this.loanDetailsService.getDelayedLoansFor(this.lenderId);
        this.portfolios = await this.getAllPortfolios(delayedLoans, this.lenderId);
        this.npaLoans = remove(delayedLoans, loan => this.npaLoansFilter.onFilterApplied(loan));
        this.nonNpaDelayedLoans = delayedLoans;
        this.networkCallInProgress = false;
    }

    protected async getAllPortfolios(delayedLoans: Loan[], lenderId: string): Promise<Map<string, Portfolio>> {
        const portfolioIds = uniq(delayedLoans.map((delayedLoan) => {
            const lendersInvested = delayedLoan.lenders_invested.find(investment => investment.lender_id === lenderId);
            return lendersInvested.portfolio_id;
        }));
        if (portfolioIds.length === 0) {
            return;
        }
        const portfolios = await this.portfolioService.getPortfoliosByIds(portfolioIds);
        const portfolioIdToPortfolio = new Map<string, any>();
        portfolios.forEach((portfolio) => portfolioIdToPortfolio.set(portfolio._id, portfolio));
        return portfolioIdToPortfolio;
    }
}
